import type { DebtDTO } from '@shared/types';

/** Vista previa en el cliente del interés del mes (el backend recalcula igual al guardar). */
export function monthlyInterestPreview(debt: DebtDTO): number {
  return debt.monthlyInterest;
}
